import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { PositionProvider } from "../../../context/PositionContext";

export const Safari = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddSafari = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditSafari = () => {
  return (
    
      
        <Edit />
      
    
  );
};

export const ViewSafari = () => {
  return (
    
      <Detail />
    
  );
};
